import { ref, watch, computed } from '@vue/composition-api';
import store from '@/store';

// Notification
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { useToast } from 'vue-toastification/composition';

export default function useTendersList() {

	// Use toast
	const toast = useToast()

	const refTenderListTable = ref(null)

	const styleColumns = {
		thClass: 'text-center',
		tdClass: 'text-center'
	}

	// Table Handlers
	let tableColumns = [
		{ key: 'code', sortable: true, label: 'CÓDIGO', ...styleColumns },
		{ key: 'title', sortable: true, label: 'LICITACIÓN', thClass: styleColumns.thClass },
		{ key: 'tender_state_name', sortable: true, label: 'ESTADO', ...styleColumns },
		/* { key: 'invitations_count', sortable: true, label: 'N° POSTORES <br/> INVITADOS', ...styleColumns }, */
		{ key: 'bidders_count', sortable: true, label: 'N° POSTORES <br/> PARTICIPANTES', ...styleColumns },
		{ key: 'is_published', sortable: true, label: 'ESTADO <br/> PUBLICACIÓN', ...styleColumns },
		{ key: 'published_at', sortable: true, label: 'FECHA <br/> REGISTRO', ...styleColumns },
		{ key: 'actions', sortable: false, label: 'OPCIONES', ...styleColumns }
	];

	const perPage = ref(10);
	const totalTenders = ref(0);
	const currentPage = ref(1);
	const perPageOptions = [10, 25, 50, 100];
	const searchQuery = ref('');
	const sortBy = ref('createdAt');
	const isSortDirDesc = ref(true);

	const publicStatesFilter = ref(null);
	const tenderStatesFilter = ref(null);

	const dataMeta = computed(() => {
		const localItemsCount = refTenderListTable.value ? refTenderListTable.value.localItems.length : 0;
		return {
			from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
			to: perPage.value * (currentPage.value - 1) + localItemsCount,
			of: totalTenders.value,
		}
	});

	const refetchData = () => {
		refTenderListTable.value.refresh();
	};

	watch([currentPage, perPage, searchQuery, publicStatesFilter, tenderStatesFilter], () => {
		refetchData();
	});

	const fetchTenders = (ctx, callback) => {


		store
			.dispatch('app-tender/fetchTenders', {
				q: searchQuery.value,
				perPage: perPage.value,
				page: currentPage.value,
				sortBy: sortBy.value,
				sortDesc: isSortDirDesc.value,
				publicStates: publicStatesFilter.value,
				tenderStates: tenderStatesFilter.value
			})
			.then(response => {
				const { tenders, total } = response.data;
				callback(tenders);
				totalTenders.value = total;
			})
			.catch(() => {
				toast({
					component: ToastificationContent,
					props: {
						title: 'Error al obtener la lista de licitaciones',
						icon: 'AlertTriangleIcon',
						variant: 'danger'
					}
				});
			})
	};

	return {
		fetchTenders,
		tableColumns,
		perPage,
		currentPage,
		totalTenders,
		dataMeta,
		perPageOptions,
		searchQuery,
		sortBy,
		isSortDirDesc,
		refTenderListTable,

		refetchData,

		// Extra Filters
		publicStatesFilter,
		tenderStatesFilter,
	}
}